/* eslint-disable no-console */
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import api from '~/services/api';
import history from '~/services/history';
import * as actions from './actions';
import * as types from './types';

import {
  modalSuccess,
  modalUpdateSuccess,
} from '~/pages/LinhasDeCuidadoFormulario/dados/optionsModal';

export function* listLinhasDeCuidado({ payload }) {
  const { institutionId } = payload;

  try {
    const response = yield call(
      api.get,
      `indicadores-linhas-de-cuidado/instituicoes/${institutionId}`
    );

    yield put(
      actions.listarLcsSuccess({
        careLinesActive: response.data,
      })
    );
  } catch (error) {
    yield put(actions.listarLcsFailure());
  }
}

/**
 * ---------------------------------------------------
 *  CANCER DE MAMA
 * ---------------------------------------------------
 */

export function* sendCancerDeMama({ payload }) {
  const { data, periodo } = payload;

  try {
    const response = yield call(
      api.post,
      `indicadores-linhas-de-cuidado/cancer_de_mama/formulario-eletronico?periodo=${periodo}`,
      data
    );

    yield put(
      actions.cancerDeMamaSuccess({
        careLineData: response.data,
      })
    );
    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.cancerDeMamaSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/cancer_de_mama`,
            state: {
              periodo: payload?.periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(
      actions.cancerDeMamaFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error(
      `${error?.response?.data?.error}` || 'Ocorreu um erro ao salvar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  get cancer de mama
 */

export function* getCancerDeMama({ payload }) {
  const { id } = payload;

  try {
    const response = yield call(
      api.get,
      `indicadores-linhas-de-cuidado/cancer_de_mama/formulario-eletronico/${id}`
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.cancerDeMamaGetSuccess({
          careLineData: response.data,
        })
      );
    }
  } catch (error) {
    yield put(actions.cancerDeMamaGetFailure());

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  update cancer de mama
 */

export function* updateCancerDeMama({ payload }) {
  const { data, id, periodo } = payload;

  try {
    const response = yield call(
      api.put,
      `indicadores-linhas-de-cuidado/cancer_de_mama/formulario-eletronico/${id}`,
      data
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.cancerDeMamaUpdateSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalUpdateSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/cancer_de_mama`,
            state: {
              periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(
      actions.cancerDeMamaUpdateFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 * ---------------------------------------------------
 *    QUADRIL
 * ---------------------------------------------------
 */

export function* sendQuadril({ payload }) {
  const { data, periodo } = payload;

  try {
    const response = yield call(
      api.post,
      `indicadores-linhas-de-cuidado/artropatia_de_quadril/formulario-eletronico?periodo=${periodo}`,
      data
    );

    yield put(
      actions.quadrilSuccess({
        careLineData: response.data,
      })
    );
    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.quadrilSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/artropatia_de_quadril`,
            state: {
              periodo: payload?.periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(actions.quadrilFailure({ errorData: error?.response?.data }));

    toast.error(
      `${error?.response?.data?.error}` || 'Ocorreu um erro ao salvar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  get quadril
 */

export function* getQuadril({ payload }) {
  const { id } = payload;

  try {
    const response = yield call(
      api.get,
      `indicadores-linhas-de-cuidado/artropatia_de_quadril/formulario-eletronico/${id}`
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.quadrilGetSuccess({
          careLineData: response.data,
        })
      );
    }
  } catch (error) {
    yield put(actions.quadrilGetFailure());

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  update quadril
 */

export function* updateQuadril({ payload }) {
  const { data, id, periodo } = payload;

  try {
    const response = yield call(
      api.put,
      `indicadores-linhas-de-cuidado/artropatia_de_quadril/formulario-eletronico/${id}`,
      data
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.quadrilUpdateSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalUpdateSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/artropatia_de_quadril`,
            state: {
              periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(
      actions.quadrilUpdateFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 * ---------------------------------------------------
 *  ACIDENTE VASCULAR CEREBRAL (AVC)
 * ---------------------------------------------------
 */

export function* sendAvc({ payload }) {
  const { data, periodo } = payload;

  try {
    const response = yield call(
      api.post,
      `indicadores-linhas-de-cuidado/acidente_vascular_cerebral/formulario-eletronico?periodo=${periodo}`,
      data
    );

    yield put(
      actions.avcSuccess({
        careLineData: response.data,
      })
    );
    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.avcSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/acidente_vascular_cerebral`,
            state: {
              periodo: payload?.periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(actions.avcFailure({ errorData: error?.response?.data }));

    toast.error(
      `${error?.response?.data?.error}` || 'Ocorreu um erro ao salvar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  get avc
 */

export function* getAvc({ payload }) {
  const { id } = payload;

  try {
    const response = yield call(
      api.get,
      `indicadores-linhas-de-cuidado/acidente_vascular_cerebral/formulario-eletronico/${id}`
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.avcGetSuccess({
          careLineData: response.data,
        })
      );
    }
  } catch (error) {
    yield put(actions.avcGetFailure());

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  update avc
 */

export function* updateAvc({ payload }) {
  const { data, id, periodo } = payload;

  try {
    const response = yield call(
      api.put,
      `indicadores-linhas-de-cuidado/acidente_vascular_cerebral/formulario-eletronico/${id}`,
      data
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.avcUpdateSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalUpdateSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/acidente_vascular_cerebral`,
            state: {
              periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(
      actions.avcUpdateFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 * ---------------------------------------------------
 *  SCA
 * ---------------------------------------------------
 */

export function* sendSca({ payload }) {
  const { data, periodo } = payload;

  try {
    const response = yield call(
      api.post,
      `indicadores-linhas-de-cuidado/sindrome_coronariana_aguda/formulario-eletronico?periodo=${periodo}`,
      data
    );

    yield put(
      actions.scaSuccess({
        careLineData: response.data,
      })
    );
    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.scaSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/sindrome_coronariana_aguda`,
            state: {
              periodo: payload?.periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(actions.scaFailure({ errorData: error?.response?.data }));

    toast.error(
      `${error?.response?.data?.error}` || 'Ocorreu um erro ao salvar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  get sca
 */

export function* getSca({ payload }) {
  const { id } = payload;

  try {
    const response = yield call(
      api.get,
      `indicadores-linhas-de-cuidado/sindrome_coronariana_aguda/formulario-eletronico/${id}`
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.scaGetSuccess({
          careLineData: response.data,
        })
      );
    }
  } catch (error) {
    yield put(actions.scaGetFailure());

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  update sca
 */

export function* updateSca({ payload }) {
  const { data, id, periodo } = payload;

  try {
    const response = yield call(
      api.put,
      `indicadores-linhas-de-cuidado/sindrome_coronariana_aguda/formulario-eletronico/${id}`,
      data
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.scaUpdateSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalUpdateSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/sindrome_coronariana_aguda`,
            state: {
              periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(
      actions.scaUpdateFailure({
        errorData: error?.response?.data,
      })
    );
    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  calculo de grace
 */

export function* graceRisk({ payload }) {
  const { data } = payload;

  try {
    const response = yield call(
      api.post,
      `indicadores-linhas-de-cuidado/sindrome_coronariana_aguda/calculate-grace-score`,
      data
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.graceSuccess({
          graceScore: response.data,
        })
      );
    }
  } catch (error) {
    yield put(actions.graceFailure());
  }
}

/**
 * ---------------------------------------------------
 *  CANCER DE PROSTATA
 * ---------------------------------------------------
 */

export function* sendCancerDeProstata({ payload }) {
  const { data, periodo } = payload;

  try {
    const response = yield call(
      api.post,
      `indicadores-linhas-de-cuidado/cancer_de_prostata/formulario-eletronico?periodo=${periodo}`,
      data
    );

    yield put(
      actions.cancerDeProstataSuccess({
        careLineData: response.data,
      })
    );
    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.cancerDeProstataSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/cancer_de_prostata`,
            state: {
              periodo: payload?.periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(
      actions.cancerDeProstataFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error(
      `${error?.response?.data?.error}` || 'Ocorreu um erro ao salvar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  get cancer de prostata
 */

export function* getCancerDeProstata({ payload }) {
  const { id } = payload;

  try {
    const response = yield call(
      api.get,
      `indicadores-linhas-de-cuidado/cancer_de_prostata/formulario-eletronico/${id}`
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.cancerDeProstataGetSuccess({
          careLineData: response.data,
        })
      );
    }
  } catch (error) {
    yield put(actions.cancerDeProstataGetFailure());

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  update cancer de prostata
 */

export function* updateCancerDeProstata({ payload }) {
  const { data, id, periodo } = payload;

  try {
    const response = yield call(
      api.put,
      `indicadores-linhas-de-cuidado/cancer_de_prostata/formulario-eletronico/${id}`,
      data
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.cancerDeProstataUpdateSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalUpdateSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/cancer_de_prostata`,
            state: {
              periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(
      actions.cancerDeProstataUpdateFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 * ---------------------------------------------------
 *  SEPSE
 * ---------------------------------------------------
 */

export function* sendSepse({ payload }) {
  const { data, periodo } = payload;

  try {
    const response = yield call(
      api.post,
      `indicadores-linhas-de-cuidado/sepse_e_choque_septico/formulario-eletronico?periodo=${periodo}`,
      data
    );

    yield put(
      actions.sepseSuccess({
        careLineData: response.data,
      })
    );
    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.sepseSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/sepse_e_choque_septico`,
            state: {
              periodo: payload?.periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(actions.sepseFailure({ errorData: error?.response?.data }));

    toast.error(
      `${error?.response?.data?.error}` || 'Ocorreu um erro ao salvar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  get sca
 */

export function* getSepse({ payload }) {
  const { id } = payload;

  try {
    const response = yield call(
      api.get,
      `indicadores-linhas-de-cuidado/sepse_e_choque_septico/formulario-eletronico/${id}`
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.sepseGetSuccess({
          careLineData: response.data,
        })
      );
    }
  } catch (error) {
    yield put(actions.sepseGetFailure());

    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

/**
 *  update sepse
 */

export function* updateSepse({ payload }) {
  const { data, id, periodo } = payload;

  try {
    const response = yield call(
      api.put,
      `indicadores-linhas-de-cuidado/sepse_e_choque_septico/formulario-eletronico/${id}`,
      data
    );

    if (String(response?.status).substr(0, 2) === '20') {
      yield put(
        actions.sepseUpdateSuccess({
          careLineData: response.data,
        })
      );

      Swal.fire(modalUpdateSuccess).then(result => {
        if (result) {
          history.push({
            pathname: `/linha-de-cuidado/sepse_e_choque_septico`,
            state: {
              periodo,
            },
          });
        }
      });
    }
  } catch (error) {
    yield put(
      actions.sepseUpdateFailure({
        errorData: error?.response?.data,
      })
    );
    toast.error(
      `${error?.response?.data?.error}` ||
        'Ocorreu um erro ao atualizar os dados',
      { autoClose: 7000 }
    );
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `${token}`;
  }
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest(types.LISTAR_LCS_REQUEST, listLinhasDeCuidado),
  takeLatest(types.LC_CANCER_MAMA_REQUEST, sendCancerDeMama),
  takeLatest(types.LC_CANCER_MAMA_UPDATE_REQUEST, updateCancerDeMama),
  takeLatest(types.GET_CANCER_MAMA_REQUEST, getCancerDeMama),
  takeLatest(types.LC_AVC_REQUEST, sendAvc),
  takeLatest(types.LC_AVC_UPDATE_REQUEST, updateAvc),
  takeLatest(types.GET_AVC_REQUEST, getAvc),
  takeLatest(types.LC_SCA_REQUEST, sendSca),
  takeLatest(types.LC_SCA_UPDATE_REQUEST, updateSca),
  takeLatest(types.GET_SCA_REQUEST, getSca),
  takeLatest(types.LC_CANCER_PROSTATA_REQUEST, sendCancerDeProstata),
  takeLatest(types.LC_CANCER_PROSTATA_UPDATE_REQUEST, updateCancerDeProstata),
  takeLatest(types.GET_CANCER_PROSTATA_REQUEST, getCancerDeProstata),
  takeLatest(types.LC_SEPSE_REQUEST, sendSepse),
  takeLatest(types.LC_SEPSE_UPDATE_REQUEST, updateSepse),
  takeLatest(types.GET_SEPSE_REQUEST, getSepse),
  takeLatest(types.LC_QUADRIL_REQUEST, sendQuadril),
  takeLatest(types.LC_QUADRIL_UPDATE_REQUEST, updateQuadril),
  takeLatest(types.GET_QUADRIL_REQUEST, getQuadril),
  takeLatest(types.GRACE_REQUEST, graceRisk),
]);
